/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { request as __request } from "../core/request";

export class CheckProjectNameService {
  /**
   * @returns any
   * @throws ApiError
   */
  public static async checkProjectNameList(): Promise<any> {
    const result = await __request({
      method: "GET",
      path: `/check_project_name`,
    });
    return result.body;
  }
}
